import React, { useEffect } from 'react';
import { Text, View, Picker, StyleSheet } from 'react-native';
import EonnField from './field';
import { mstyles } from '../constants/MainStyles';

const PhoneField = ({ 
  phoneValue = "", 
  countryCode = "+1", 
  onPhoneChange, 
  onCountryCodeChange, 
  showRequired = false,
  label = "Phone Number",
  children,
  hideCountryCodePicker = false,
  countryCodes
}) => {
  const defaultCountryCodes = [
    { code: "+1", country: "US/Canada" },
    { code: "+44", country: "UK" },
    { code: "+61", country: "Australia" },
    { code: "+91", country: "India" },
    { code: "+33", country: "France" },
    { code: "+34", country: "Spain" },
    { code: "+49", country: "Germany" },
    { code: "+52", country: "Mexico" },
    { code: "+55", country: "Brazil" },
    { code: "+81", country: "Japan" },
    { code: "+82", country: "South Korea" },
    { code: "+86", country: "China" },
    { code: "+234", country: "Nigeria" },
  ];
  const codes = (Array.isArray(countryCodes) && countryCodes.length > 0) ? countryCodes : defaultCountryCodes;

  // Automatically set country code to +1 when hideCountryCodePicker is true
  useEffect(() => {
    if (hideCountryCodePicker && countryCode !== "+1") {
      onCountryCodeChange?.("+1");
    }
  }, [hideCountryCodePicker, countryCode, onCountryCodeChange]);

  const styles = StyleSheet.create({
    phoneWrapper: {
      maxWidth: '85%',
      margin: 10,
    },
    phoneContainer: {
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
    countryCodePicker: {
      width: 65,
      borderWidth: 1,
      borderColor: '#ccc',
      borderRadius: 4,
      marginRight: 10,
    },
    staticCountryCode: {
      width: 35,
      height: 40,
      marginRight: 10,
      justifyContent: 'center',
      alignItems: 'center',
    },
    staticCountryCodeText: {
      color: '#2e303e',
      fontSize: 16,
      fontFamily: 'nunito',
      fontWeight: '500',
    },
    phoneFieldContainer: {
      flex: 1,
    },
    label: {
      color: '#2e303e',
      fontSize: 18,
      fontFamily: 'nunito',
      lineHeight: 21,
      marginBottom: 5,
      maxWidth: '85%',
      width: 500,
      textAlign: 'left',
    },
  });

  return (
    <View style={styles.phoneWrapper}>
      <Text style={styles.label}>
        {children || label}
      </Text>
      <View style={styles.phoneContainer}>
        {hideCountryCodePicker ? (
          <View style={styles.staticCountryCode}>
            <Text style={styles.staticCountryCodeText}>+1</Text>
          </View>
        ) : (
          <View style={styles.countryCodePicker}>
            <Picker
              selectedValue={countryCode}
              style={{ height: 40 }}
              onValueChange={(itemValue) => {
                onCountryCodeChange?.(itemValue);
              }}
            >
              {codes.map((item, index) => (
                <Picker.Item key={index} label={item.code} value={item.code} />
              ))}
            </Picker>
          </View>
        )}
        <View style={styles.phoneFieldContainer}>
          <EonnField
            onChange={onPhoneChange}
            showRequired={showRequired}
            value={phoneValue}
            keyboardType="phone-pad"
            inputWrapperStyle={{ 
              maxWidth: '100%', 
              marginRight: 0, 
              marginTop: 0, 
              marginBottom: 0,
              margin: 0 
            }}
            inputStyle={{ 
              width: '100%', 
              marginTop: 0, 
              marginBottom: 0 
            }}
            labelStyle={{ 
              marginTop: 0, 
              marginBottom: 0 
            }}
          >
          </EonnField>
        </View>
      </View>
    </View>
  );
};

export default PhoneField;